export const fieldsToMapValidation: Array<{ [key: string]: string[] }> = [
  { 'COMPANY.IOR.FIRST_NAME': ['FORM_LABEL.FIRSTNAME'] },
  { 'COMPANY.IOR.LAST_NAME': ['FORM_LABEL.LASTNAME'] },
  { 'COMPANY.IOR.EMAIL_ADDRESS': ['FORM_LABEL.EMAILADDRESS'] },
  { 'COMPANY.IOR.MOBILE_NUMBER': ['FORM_LABEL.PHONENUMBER'] },
  { 'LABELS.ABI_CLIENT_REPRESENTATIVE': ['FORM_LABEL.ABI', 'FORM_LABEL.ABI_CLIENT_REPRESENTATIVE'] },
  { 'LABELS.ACTIVE': ['FORM_LABEL.ACTIVE'] },
  { 'LABELS.ACTUAL_TIME_OF_ARRIVAL': ['FORM_LABEL.ACTUAL_TIME_OF_ARRIVAL'] },
  { 'LABELS.ACTUAL_TIME_OF_DEPARTURE': ['FORM_LABEL.ACTUAL_TIME_OF_DEPARTURE'] },
  { 'LABELS.ACTUAL_WEIGHT': ['FORM_LABEL.ACTUAL_WEIGHT'] },
  { 'LABELS.ADDRESS': ['FORM_LABEL.ADDRESS'] },
  { 'BUTTON.ADD_PERMITTED_PORT_OF_ENTRY': ['FORM_LABEL.ADD_PERMITTED_PORT_OF_ENTRY'] },
  { 'LABELS.AFFILIATE': ['FORM_LABEL.AFFILIATE'] },
  { 'LABELS.AGENT': ['FORM_LABEL.AGENT'] },
  { 'LABELS.AMOUNT': ['FORM_LABEL.AMOUNT', 'FORM_LABEL.BONDAMOUNT'] },
  { 'LABELS.ANNUAL_ESTIMATED_DUTIES_VALUE': ['FORM_LABEL.ANNUAL_ESTIMATED_DUTY_VALUE'] },
  { 'LABELS.ANNUAL_ESTIMATED_VALUE_OF_IMPORTS': ['FORM_LABEL.ANNUAL_ESTIMATED_VALUE_OF_IMPORTS'] },
  { 'LABELS.ARRIVAL_DATE': ['FORM_LABEL.ARRIVALDATE'] },
  { 'LABELS.ARRIVAL_CFS': ['FORM_LABEL.ARRIVAL_CFS'] },
  { 'LABELS.ARRIVAL_DATE': ['FORM_LABEL.ARRIVAL_DATE'] },
  { 'LABELS.ARRIVAL_PORT': ['FORM_LABEL.ARRIVAL_PORT', 'FORM_LABEL.PORTCODE'] },
  { 'MENU.BILLING_HISTORY': ['FORM_LABEL.BILLING_HISTORY'] },
  { 'LABELS.BILL_NUMBER': ['FORM_LABEL.BILL_NUMBER'] },
  { 'LABELS.BL': ['FORM_LABEL.BL'] },
  { 'LABELS.BL_NUMBER': ['FORM_LABEL.BL_NUMBER'] },
  { 'LABELS.BOND_TYPE': ['FORM_LABEL.BOND_TYPE'] },
  { 'BOND_TYPE.CONTINUOUS': ['FORM_LABEL.BOND_TYPE_CONTINUOUS'] },
  { 'BOND_TYPE.SINGLE_TRANSACTION': ['FORM_LABEL.BOND_TYPE_SINGLE'] },
  { 'LABELS.QUOTE_REFERENCE_NUMBER': ['FORM_LABEL.QUOTE_REFERENCE_NUMBER'] },
  { 'LABELS.BROKER': ['FORM_LABEL.BROKER'] },
  { 'LABELS.BROKEN_BY': ['FORM_LABEL.BROKEN_BY'] },
  { 'LABELS.BROKEN_DATE': ['FORM_LABEL.BROKEN_DATE'] },
  { 'LABELS.BRUTTO_WEIGHT': ['FORM_LABEL.BRUTTO_WEIGHT'] },
  { 'LABELS.BUSINESS_ADDRESS': ['FORM_LABEL.BUSINESS_ADDRESS'] },
  { 'LABELS.BUSINESS_ID_NUMBER': ['FORM_LABEL.BUSINESS_IDENTIFIER'] },
  { 'LABELS.ANI_HINT': ['FORM_LABEL.BUSINESS_IDENTIFIER_CBP'] },
  { 'LABELS.BUSINESS_TYPE': ['FORM_LABEL.BUSINESS_TYPE'] },
  { 'LABELS.CARRIER': ['FORM_LABEL.CARRIER'] },
  { 'LABELS.CASE_COUNT': ['FORM_LABEL.CASE_COUNT'] },
  { 'LABELS.CHARGES': ['FORM_LABEL.CHARGES', 'FORM_LABEL.TRANSPORTATIONCHARGE'] },
  { 'LABELS.CITY': ['FORM_LABEL.CITY'] },
  { 'LABELS.CODE': ['FORM_LABEL.CODE'] },
  { 'LABELS.COMPANY': ['FORM_LABEL.COMPANY'] },
  { 'LABELS.CONTAINER': ['FORM_LABEL.CONTAINER'] },
  { 'LABELS.CONTAINER_SPEC': ['FORM_LABEL.CONTAINER_SPEC'] },
  { 'DASHBOARD_TITLE.CONTAINER_SUB_COST': ['FORM_LABEL.CONTAINER_SUB_COSTS'] },
  { 'LABELS.CONTAINER_NUMBER': ['FORM_LABEL.CONTAINERNUMBER', 'FORM_LABEL.CONTAINER_NUMBER'] },
  { 'MENU.CONTAINERS': ['FORM_LABEL.CONTAINERS'] },
  { 'LABELS.CONTAINER_PREPARATION_CUTOFF': ['FORM_LABEL.CONTAINER_PREPARATION_CUTOFF'] },
  { 'LABELS.CONTAINER_TYPE': ['FORM_LABEL.CONTAINER_TYPE'] },
  { 'LABELS.CONVERSION_RATE_TODAY': ['FORM_LABEL.CONVERSATION_RATE'] },
  { 'LABELS.COUNTRY': ['FORM_LABEL.COUNTRY'] },
  { 'LABELS.COUNTRY_OF_EXPORT': ['FORM_LABEL.COUNTRYOFEXPORT', 'FORM_LABEL.COUNTRYOFEXPORTID'] },
  { 'LABELS.COUNTRY_OF_ORIGIN': ['FORM_LABEL.COUNTRYOFORIGINID', 'FORM_LABEL.COUNTRY_OF_EXPORT'] },
  { 'LABELS.COUPON': ['FORM_LABEL.COUPON'] },
  { 'LABELS.COUPON_TYPE': ['FORM_LABEL.COUPON_TYPE'] },
  { 'CFS_TYPE.COLOADING': ['FORM_LABEL.COLOADING'] },
  { 'LABELS.CREATED_DATE': ['FORM_LABEL.CREATED_DATE'] },
  { 'LABELS.CURRENCY': ['FORM_LABEL.CURRENCY'] },
  { 'LABELS.DATABASE': ['FORM_LABEL.DATABASE'] },
  { 'LABELS.DATE': ['FORM_LABEL.DATE'] },
  { 'LABELS.DATES': ['FORM_LABEL.DATES'] },
  { 'LABELS.DATE_OF_BIRTH': ['FORM_LABEL.DATE_OF_BIRTH'] },
  { 'LABELS.DEFAULT': ['FORM_LABEL.DEFAULT'] },
  { 'LABELS.DEFAULT_AFFILIATE': ['FORM_LABEL.DEFAULT_AFFILIATE'] },
  { 'LABELS.DEFAULT_BROKER': ['FORM_LABEL.DEFAULT_BROKER'] },
  { 'LABELS.DELIVERY_PLACE': ['FORM_LABEL.DELIVERY_PLACE'] },
  { 'LABELS.DEPARTMENT': ['FORM_LABEL.DEPARTMENT'] },
  { 'LABELS.DEPARTURE_CFS': ['FORM_LABEL.DEPARTURE_CFS'] },
  { 'LABELS.DEPARTURE_DATE': ['FORM_LABEL.DEPARTURE_DATE'] },
  { 'LABELS.DEPARTURE_NUMBER': ['FORM_LABEL.DEPARTURE_NUMBER'] },
  { 'LABELS.DEPARTURE_PORT': ['FORM_LABEL.DEPARTURE_PORT'] },
  { 'LABELS.DESCRIPTION': ['FORM_LABEL.DESCRIPTION'] },
  { 'LABELS.DESTINATION_PORT': ['FORM_LABEL.DESTINATION_PORT'] },
  { 'LABELS.DESTINATION_PRICELIST': ['FORM_LABEL.DESTINATION_PRICELIST'] },
  { 'LABELS.DOCUMENTS_PREPARATION_CUTOFF': ['FORM_LABEL.DOCUMENTS_PREPARATION_CUTOFF'] },
  { 'LABELS.DUTIES_PAYMENT_TYPE': ['FORM_LABEL.DUTIESPAYMENTTYPE'] },
  { 'LABELS.EEZYIMPORT_PRICE': ['FORM_LABEL.EEZYIMPORT_PRICE'] },
  { 'LABELS.EFFECTIVE_DATE': ['FORM_LABEL.EFFECTIVE_DATE'] },
  { 'LABELS.EMAIL': ['FORM_LABEL.EMAIL'] },
  { 'LABELS.END_DATE': ['FORM_LABEL.END_DATE'] },
  { 'LABELS.END_DATE_TIME': ['FORM_LABEL.END_DATE_TIME'] },
  { 'LABELS.ID_NUMBER': ['FORM_LABEL.ENTITYIDENTIFIER', 'FORM_LABEL.IDENTIFIER'] },
  { 'LABELS.ENTITY_IDENTIFIER_QUALIFIER': ['FORM_LABEL.ENTITYIDENTIFIERQUALIFIER'] },
  { 'LABELS.ETD': ['FORM_LABEL.ETD'] },
  { 'LABELS.ETA': ['FORM_LABEL.ETA'] },
  { 'LABELS.ESTIMATED_TIME_OF_ARRIVAL': ['FORM_LABEL.ESTIMATED_TIME_OF_ARRIVAL'] },
  { 'FORM_LABEL.EXPORT_DATE': ['FORM_LABEL.EXPORTDATE'] },
  { 'LABELS.EXPORT_REFERENCE': ['FORM_LABEL.EXPORT_REFERENCE'] },
  { 'LABELS.FAX': ['FORM_LABEL.FAX'] },
  { 'LABELS.FAX_NUMBER': ['FORM_LABEL.FAX_NUMBER'] },
  { 'LABELS.FINAL_DESTINATION': ['FORM_LABEL.FINAL_DESTINATION'] },
  { 'LABELS.FIRST_NAME': ['FORM_LABEL.FIRST_NAME', 'FORM_LABEL.LOGIN_FIRSTNAME'] },
  { 'FORM_LABEL.FLIGHT_NUMBER': ['FORM_LABEL.FLIGHTNUMBER'] },
  { 'FORM_LABEL.FOREIGN_PORT': ['FORM_LABEL.FOREIGNPORTOFLADINGID'] },
  { 'FORM_LABEL.FREIGHT_COST': ['FORM_LABEL.FREIGHTCOST'] },
  { 'LABELS.FREIGHT_PAYMENT_PLACE': ['FORM_LABEL.FREIGHT_PAYMENT_PLACE'] },
  { 'LABELS.FROM': ['FORM_LABEL.FROM'] },
  { 'LABELS.FULL_CONTAINER': ['FORM_LABEL.FULL_CONTAINER'] },
  { 'LABELS.GROSS_WEIGHT': ['FORM_LABEL.GROSSWEIGHT', 'FORM_LABEL.GROSS_WEIGHT'] },
  { 'LABELS.HBL': ['FORM_LABEL.HBL'] },
  { 'LABELS.HOUSE_BILL': ['FORM_LABEL.HOUSE_BILL', 'FORM_LABEL.HOUSE_BILL_OF_LADING'] },
  { 'FORM_LABEL.HTS_CODE': ['FORM_LABEL.HTSNUMBER', 'FORM_LABEL.HTS_NUMBER'] },
  { 'LABELS.HTS_VALIDATION_PENDING': ['FORM_LABEL.HTSVALIDATION'] },
  { 'LABELS.INCOTERM': ['FORM_LABEL.INCOTERM'] },
  { 'LABELS.INCOTERMS': ['FORM_LABEL.INCOTERMID', 'FORM_LABEL.INCOTERMS'] },
  { 'LABELS.INSURANCE_VALUE': ['FORM_LABEL.INSURANCE_VALUE'] },
  { 'LABELS.INTERNAL_DESCRIPTION': ['FORM_LABEL.INTERNAL_DESCRIPTION'] },
  { 'LABELS.INTERNAL_NOTE': ['FORM_LABEL.INTERNAL_NOTE'] },
  { 'LABELS.INTERNATIONAL_HTS_CODE': ['FORM_LABEL.INTERNATIONAL_HTS_CODE'] },
  { 'LABELS.INVOICE_NUMBER': ['FORM_LABEL.INVOICENUMBER', 'FORM_LABEL.INVOICE_NUMBER'] },
  { 'LABELS.IS_DISCOUNTABLE': ['FORM_LABEL.IS_DISCOUNTABLE'] },
  { 'LABELS.IS_TAXABLE': ['FORM_LABEL.IS_TAXABLE'] },
  { 'FORM_LABEL.MASTER_BILL_OF_LADING': ['FORM_LABEL.ISF_REF_MB'] },
  { 'LABELS.IS_OPTIONAL': ['FORM_LABEL.IS_OPTIONAL'] },
  { 'LABELS.ISSUE_DATE': ['FORM_LABEL.ISSUE_DATE'] },
  { 'FORM_LABEL.IT_DATE': ['FORM_LABEL.ITDATE'] },
  { 'LABELS.ITEM_DESCRIPTION': ['FORM_LABEL.ITEM_DESCRIPTION'] },
  { 'FORM_LABEL.IT_NUMBER': ['FORM_LABEL.ITNUMBER'] },
  { 'LABELS.FIXED_PRICE': ['FORM_LABEL.FIXED_PRICE'] },
  { 'LABELS.JOB_TITLE': ['FORM_LABEL.JOB_TITLE'] },
  { 'LABELS.LAST_NAME': ['FORM_LABEL.LAST_NAME', 'FORM_LABEL.LOGIN_LASTNAME'] },
  { 'LABELS.LATITUDE': ['FORM_LABEL.LATITUDE'] },
  { 'LABELS.LDS_CONNECTION': ['FORM_LABEL.LDS_CONNECTION'] },
  { 'LABELS.LENGTH': ['FORM_LABEL.LENGTH'] },
  { 'LABELS.LICENCE_PLATE_NUMBER': ['FORM_LABEL.LICENCE_PLATE_NUMBER'] },
  { 'LABELS.LINE': ['FORM_LABEL.LINE'] },
  { 'LABELS.LINE1': ['FORM_LABEL.LINE1'] },
  { 'LABELS.LOCATION': ['FORM_LABEL.LOCATION'] },
  { 'FORM_LABEL.LOCATION_OF_GOODS': ['FORM_LABEL.LOCATIONCODE'] },
  { 'FORM_LABEL.CONFIRM_PASSWORD': ['FORM_LABEL.LOGIN_CONFIRM_PASSWORD'] },
  { 'LABELS.PASSWORD': ['FORM_LABEL.LOGIN_PASSWORD', 'FORM_LABEL.PASSWORD'] },
  { 'LABELS.LONGITUDE': ['FORM_LABEL.LONGITUDE'] },
  { 'LABELS.LOT_NUMBER': ['FORM_LABEL.LOT_NUMBER'] },
  { 'LABELS.LPN': ['FORM_LABEL.LPN'] },
  { 'LABELS.MARGIN': ['FORM_LABEL.MARGIN'] },
  { 'LABELS.MARKS_AND_NUMBERS': ['FORM_LABEL.MARKS', 'FORM_LABEL.MARKS_AND_NUMBERS'] },
  { 'LABELS.MAX_LOAD': ['FORM_LABEL.MAX_LOAD'] },
  { 'FORM_LABEL.MEASUREMENTS': ['FORM_LABEL.MEASUREMENT'] },
  { 'LABELS.MIN_LOAD': ['FORM_LABEL.MIN_LOAD'] },
  { 'LABELS.NAME': ['FORM_LABEL.NAME'] },
  { 'LABELS.NET_WEIGHT': ['FORM_LABEL.NET_WEIGHT'] },
  { 'LABELS.NO': ['FORM_LABEL.NO'] },
  { 'LABELS.NOTE': ['FORM_LABEL.NOTE'] },
  { 'LABELS.NOTES': ['FORM_LABEL.NOTES'] },
  { 'ENTRY_SUMMARY.BILL_OF_LADING': ['FORM_LABEL.NUMBER'] },
  { 'LABELS.OPENING_HOURS': ['FORM_LABEL.OPENING_HOURS'] },
  { 'LABELS.OPTIONS': ['FORM_LABEL.OPTIONS'] },
  { 'LABELS.ORDER_NUMBER': ['FORM_LABEL.ORDER_NUMBER'] },
  { 'LABELS.ORIGIN_PRICELIST': ['FORM_LABEL.ORIGIN_PRICELIST'] },
  { 'LABELS.PACKAGE_TYPE': ['FORM_LABEL.PACKAGE_TYPE'] },
  { 'LABELS.PACKING_LIST_ITEM': ['FORM_LABEL.PACKING_LIST_ITEM'] },
  { 'FORM_LABEL.PART_ID': ['FORM_LABEL.PARTID'] },
  { 'LABELS.PAYER_UNIT_NUMBER': ['FORM_LABEL.PAYERUNITNUMBER', 'FORM_LABEL.PAYER_UNIT_NUMBER'] },
  { 'LABELS.PAYMENT_STATE': ['FORM_LABEL.PAYMENT_STATE'] },
  { 'LABELS.PERCENTS': ['FORM_LABEL.PERCENTS'] },
  { 'LABELS.MOBILE_NUMBER': ['FORM_LABEL.PHONE', 'FORM_LABEL.PHONE_NUMBER'] },
  { 'LABELS.PHONE_NUMBER': ['FORM_LABEL.PHONE_NUMBER_PHONE'] },
  { 'LABELS.OPENING_HOURS': ['FORM_LABEL.OPENING_HOURS'] },
  { 'LABELS.PICKUP_DATE_TIME_FROM': ['FORM_LABEL.PICKUPTIMEFROM'] },
  { 'LABELS.PICKUP_DATE_TIME_TO': ['FORM_LABEL.PICKUPTIMETO'] },
  { 'LABELS.PLACE_OF_ISSUE': ['FORM_LABEL.PLACE_OF_ISSUE'] },
  { 'LABELS.PO_BOX': ['FORM_LABEL.PO_BOX'] },
  { 'LABELS.POINTS': ['FORM_LABEL.POINTS'] },
  { 'LABELS.POSTAL_CODE': ['FORM_LABEL.POSTALCODE'] },
  { 'FORM_LABEL.PORT_OF_ENTRY': ['FORM_LABEL.PORTOFENTRYCODE'] },
  { 'FORM_LABEL.PORT_OF_UNLADING_ARRIVAL': ['FORM_LABEL.PORTOFUNLADINGCODE'] },
  { 'LABELS.PORT': ['FORM_LABEL.PORT'] },
  { 'LABELS.PREPARATION_CUTOFF': ['FORM_LABEL.PREPARATION_CUTOFF'] },
  { 'LABELS.PRICE': ['FORM_LABEL.PRICE'] },
  { 'LABELS.PRICING_TYPE': ['FORM_LABEL.PRICING_TYPE'] },
  { 'LABELS.PRODUCT': ['FORM_LABEL.PRODUCT'] },
  { 'LABELS.PUBLISHING_STATE': ['FORM_LABEL.PUBLISHING_STATE'] },
  { 'LABELS.QUANTITY': ['FORM_LABEL.QUANTITY'] },
  { 'LABELS.UNIT_OF_MEASURE': ['FORM_LABEL.QUANTITYUNIT'] },
  { 'LABELS.QTY': ['FORM_LABEL.QUANTITY_SHORT'] },
  { 'LABELS.RECEIPT_PLACE': ['FORM_LABEL.RECEIPT_PLACE'] },
  { 'LABELS.REFERENCE_NUMBER': ['FORM_LABEL.REFERENCENUMBER'] },
  { 'LABELS.REMARKS': ['FORM_LABEL.REMARKS'] },
  { 'LABELS.ROUTE': ['FORM_LABEL.ROUTE'] },
  { 'LABELS.SEAL_NUMBER': ['FORM_LABEL.SEAL_NUMBER'] },
  { 'LABELS.SET_DATE': ['FORM_LABEL.SET_DATE'] },
  { 'FORM_LABEL.HOUSE': ['FORM_LABEL.SHIPMENT.BM'] },
  { 'FORM_LABEL.MASTER': ['FORM_LABEL.SHIPMENT.OB'] },
  { 'LABELS.SHIPMENT': ['FORM_LABEL.SHIPMENTID'] },
  { 'LABELS.SHIPPING_ORDER_REMARKS': ['FORM_LABEL.SHIPPING_ORDER_REMARKS'] },
  { 'FORM_LABEL.SPECIAL_CHAPTER_HTS_CODE': ['FORM_LABEL.SPECIALCHAPTERHTSNUMBER'] },
  { 'LABELS.STACKABLE': ['FORM_LABEL.STACKABLE'] },
  { 'LABELS.START_DATE': ['FORM_LABEL.START_DATE'] },
  { 'LABELS.START_DATE_TIME': ['FORM_LABEL.START_DATE_TIME'] },
  { 'LABELS.STATE': ['FORM_LABEL.STATECODE'] },
  { 'FORM_LABEL.STATE_OF_DESTINATION': ['FORM_LABEL.STATEOFDESTINATION'] },
  { 'FORM_LABEL.STATE_OF_ORIGIN': ['FORM_LABEL.STATEOFORIGIN'] },
  { 'LABELS.STATE_OF_INCORPORATION': ['FORM_LABEL.STATE_OF_INCORPORATION'] },
  { 'LABELS.STATUS': ['FORM_LABEL.STATUS'] },
  { 'LABELS.TAG': ['FORM_LABEL.TAG'] },
  { 'LABELS.TARA_WEIGHT': ['FORM_LABEL.TARA_WEIGHT'] },
  { 'LABELS.THRESHOLD': ['FORM_LABEL.THRESHOLD'] },
  { 'LABELS.TIMEZONE': ['FORM_LABEL.TIMEZONE'] },
  { 'LABELS.TO': ['FORM_LABEL.TO'] },
  { 'LABELS.TOTAL_CASES_COUNT': ['FORM_LABEL.TOTAL_CASES_COUNT'] },
  { 'LABELS.TOTAL_UNITS_COUNT': ['FORM_LABEL.TOTAL_UNITS_COUNT'] },
  { 'LABELS.TYPE': ['FORM_LABEL.TYPE'] },
  { 'LABELS.TRACKING_STATE': ['FORM_LABEL.TRACKING_STATE'] },
  { 'LABELS.VOYAGE_NUMBER': ['FORM_LABEL.TRIP', 'FORM_LABEL.VESSEL_TRIP_NUMBER'] },
  { 'LABELS.TYPICAL_GOODS_VOLUME': ['FORM_LABEL.TYPICAL_GOODS_VOLUME'] },
  { 'FORM_LABEL.ENTERED_VALUE': ['FORM_LABEL.VALUE'] },
  { 'LABELS.VENDOR_COST': ['FORM_LABEL.VENDOR_COST'] },
  { 'LABELS.VESSEL_NAME': ['FORM_LABEL.VESSELNAME', 'FORM_LABEL.VESSEL_NAME'] },
  { 'LABELS.VOLUME': ['FORM_LABEL.VOLUME'] },
  { 'MENU.VOYAGES': ['FORM_LABEL.VOYAGE'] },
  { 'ADDRESS_TYPE.WAREHOUSE': ['FORM_LABEL.WAREHOUSE'] },
  { 'LABELS.WAREHOUSE_PREPARATION_CUTOFF': ['FORM_LABEL.WAREHOUSE_PREPARATION_CUTOFF'] },
  { 'LABELS.WEIGHT': ['FORM_LABEL.WEIGHT'] },
  { 'LABELS.WIDTH': ['FORM_LABEL.WIDTH'] },
  { 'LABELS.YES': ['FORM_LABEL.YES'] },
  { 'FORM_LABEL.MEASUREMENT': ['FORM_LABEL.MEASUREMENTS'] },
];
